module.exports = __webpack_public_path__ + "img/bg-caa37e.png";